export default "__VITE_ASSET__Cxryaldy__"